export default "__VITE_ASSET__CxIvWnJ$__"